import {AxiosError, AxiosResponse} from "axios";

// tslint:disable-next-line: no-any
export function handleSuccessResponse(response: AxiosResponse): Promise<any> {
  return Promise.resolve(response.data);
}

export function handleErrorResponse(error: AxiosError): Promise<ValidationErrorResponse> {
  // console.info("handleErrorResponse", error.response);
  if (!error.response) {
    throw new Error(error.message);
  }
  if (isCustomValidationErrorResponse(error.response) || isSpringValidationErrorResponse(error.response)) {
    return Promise.reject(error.response as ValidationErrorResponse);
  } else {
    throw new Error('Unknown error occurred: ' + JSON.stringify(error.response.data));
  }
}

export function isCustomValidationErrorResponse(response: AxiosResponse): response is ValidationErrorResponse {
  return response !== undefined && response.status === 422 && response.data && response.data.fieldErrors;
}

export function isSpringValidationErrorResponse(response: AxiosResponse): response is ValidationErrorResponse {
  return response !== undefined && response.status === 400 && response.data && response.data.fieldErrors;
}

/**
 * Error code the account service returns when a user with the given email already exists.
 *
 * The existing user may be invisible for the current admin, e.g. if he only has roles in other applications.
 * Repeating the request with upsert = true adds the requested application roles to that existing user.
 */
export const USER_EXISTS_ALREADY = 'USER_EXISTS_ALREADY';

export function hasFieldErrorCode(error: any, code: string): boolean {
  return !!error?.data?.fieldErrors?.some((fieldError: FieldError) => fieldError.defaultMessage === code);
}

export interface FieldError {
  field: string;
  objectName: string;
  code: string;
  defaultMessage: string;
}

export interface ValidationErrors {
  fieldErrors: FieldError[];
}

export interface ValidationErrorResponse extends AxiosResponse {
  data: ValidationErrors;
}
